import { EditPencil } from 'iconoir-react';
import { cn } from 'lib/utils';
import { useTheme } from 'components/core/theme-provider';
import { useTranslation } from 'react-i18next';

export interface WriteOrEditPrompt {
  id: string;
  title: string;
  prompt: string;
}

const WRITE_OR_EDIT_PROMPTS: WriteOrEditPrompt[] = [
  {
    id: 'rewrite-concise',
    title: 'Rewrite to be concise',
    prompt:
      'Rewrite my writing in fewer words while keeping the meaning. Here is my draft:',
  },
  {
    id: 'simplify-wording',
    title: 'Simplify my wording',
    prompt:
      'Simplify my wording while keeping the core message clear. Here is my text:',
  },
  {
    id: 'notes-to-email',
    title: 'Turn notes into an email',
    prompt: 'Turn my notes into a professional email. Here are my notes:',
  },
  {
    id: 'expand-detail',
    title: 'Expand with more detail',
    prompt:
      'Expand this writing with more detail and clarity. Here is my draft:',
  },
];

interface WriteOrEditPromptListProps {
  onSelectPrompt: (prompt: WriteOrEditPrompt) => void;
  className?: string;
}

export function WriteOrEditPromptList({
  onSelectPrompt,
  className,
}: WriteOrEditPromptListProps) {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const iconColor = theme === 'dark' ? '#F6F6F6' : '#3D3D3D';
  const textClass = theme === 'dark' ? 'text-[#F6F6F6]' : 'text-[#3D3D3D]';

  return (
    <div
      className={cn(
        'w-full overflow-hidden rounded-2xl border',
        theme === 'dark'
          ? 'border-[#3D3D3D] bg-[#292929]'
          : 'border-[#E7E7E7] bg-white',
        className
      )}
    >
      {WRITE_OR_EDIT_PROMPTS.map((item, index) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onSelectPrompt(item)}
          className={cn(
            'flex w-full items-center gap-3 px-4 py-3 text-left transition-colors',
            index < WRITE_OR_EDIT_PROMPTS.length - 1 &&
              (theme === 'dark' ? 'border-b border-[#3D3D3D]' : 'border-b border-[#E7E7E7]'),
            theme === 'dark' ? 'hover:bg-[#333333]' : 'hover:bg-[#F6F6F6]'
          )}
        >
          <EditPencil width={20} height={20} color={iconColor} />
          <span
            className={cn(
              'font-sans text-[14px] font-normal leading-[16.8px]',
              textClass
            )}
          >
            {t(`WRITE_PROMPT_${item.id.toUpperCase().replace(/-/g, '_')}`, {
              defaultValue: item.title,
            })}
          </span>
        </button>
      ))}
    </div>
  );
}
